import React from 'react';
import PageTemplate from '../PageTemplate';

const Office = () => {
  return (
    <PageTemplate
      title="🏢 사무국 안내"
      description="청소년 스마트폰 프리 운동본부 사무국 연락처"
    >
      <div style={{ padding: '2rem' }}>
        {/* 연락처 정보 */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '2rem',
          marginBottom: '3rem'
        }}>
          {/* 주소 */}
          <div style={{
            background: '#fff',
            border: '2px solid #e74c3c',
            borderRadius: '12px',
            padding: '2rem',
            textAlign: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📍</div>
            <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>사무국 주소</h3>
            <p style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#333', marginBottom: '0.5rem' }}>
              경기도 수원시 팔달구 효원로 303
            </p>
            <p style={{ fontSize: '1rem', color: '#666' }}>
              삼호파크타워 702호
            </p>
          </div>

          {/* 이메일 */}
          <div style={{
            background: '#fff',
            border: '2px solid #e74c3c',
            borderRadius: '12px',
            padding: '2rem',
            textAlign: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📧</div>
            <h3 style={{ color: '#e74c3c', marginBottom: '1rem' }}>문의 이메일</h3>
            <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333' }}>
              phonefree@gmail.com
            </p>
          </div>
        </div>

        {/* 교통편 */}
        <div style={{
          background: '#f8f9fa',
          border: '2px solid #6c757d',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h3 style={{ color: '#495057', marginBottom: '1.5rem' }}>🚇 교통편</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '1.5rem',
            textAlign: 'left'
          }}>
            <div>
              <h4 style={{ color: '#495057', marginBottom: '0.5rem' }}>지하철</h4>
              <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.6' }}>
                • 1호선 수원역 4번 출구<br/>
                • 분당선 수원시청역 2번 출구
              </p>
            </div>
            <div>
              <h4 style={{ color: '#495057', marginBottom: '0.5rem' }}>버스</h4>
              <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.6' }}>
                • 수원역.AK플라자 정류장<br/>
                • 7, 13, 35, 99번 등
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Office; 